import React from 'react';
import { Card, Box, Typography } from '@mui/material';
import { Sparklines, SparklinesLine } from 'react-sparklines';
interface SubDetail {
  label: string;
  value: string;
}
interface KPICardProps {
  title: string;
  value: string;
  icon: React.ReactNode;
  color: string;
  trend?: {
    value: number;
    label: string;
    data: number[];
  };
  subDetails?: SubDetail[];
}
export const KPICard: React.FC<KPICardProps> = ({
  title,
  value,
  icon,
  color,
  trend,
  subDetails
}) => {
  return <Card sx={{
    p: 2.5,
    borderRadius: '8px',
    border: '1px solid #E5E7EB',
    boxShadow: '0px 1px 2px rgba(0,0,0,0.05)',
    transition: 'box-shadow 200ms ease',
    height: '100%',
    '&:hover': {
      boxShadow: '0px 4px 12px rgba(0,0,0,0.08)'
    }
  }} data-id="element-581">
      <Box sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      mb: subDetails ? 1.5 : 2
    }} data-id="element-582">
        <Box data-id="element-583">
          <Typography variant="body2" sx={{
          color: '#6B7280',
          fontSize: '0.8rem',
          fontWeight: 500,
          mb: 0.5
        }} data-id="element-584">
            {title}
          </Typography>
          <Typography variant="h4" sx={{
          fontWeight: 700,
          color: '#1F2937',
          fontSize: '2rem'
        }} data-id="element-585">
            {value}
          </Typography>
        </Box>
        <Box sx={{
        width: 44,
        height: 44,
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: `${color}15`,
        color: color
      }} data-id="element-586">
          {icon}
        </Box>
      </Box>

      {subDetails && subDetails.length > 0 && <Box sx={{
      display: 'flex',
      gap: 2,
      mb: trend ? 1.5 : 0,
      pt: 1,
      borderTop: '1px solid #E5E7EB'
    }} data-id="element-587">
          {subDetails.map((detail, idx) => <Box key={idx} sx={{
        flex: 1
      }} data-id="element-588">
              <Typography variant="caption" sx={{
          color: '#6B7280',
          fontSize: '0.65rem',
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          display: 'block',
          mb: 0.25
        }} data-id="element-589">
                {detail.label}
              </Typography>
              <Typography variant="body2" sx={{
          color: '#1F2937',
          fontSize: '0.85rem',
          fontWeight: 700
        }} data-id="element-590">
                {detail.value}
              </Typography>
            </Box>)}
        </Box>}

      {trend && <Box data-id="element-591">
          <Box sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        mb: 1
      }} data-id="element-592">
            <Typography variant="caption" sx={{
          color: trend.value >= 0 ? '#0B7923' : '#AE2A19',
          fontWeight: 600,
          fontSize: '0.75rem',
          display: 'flex',
          alignItems: 'center',
          gap: 0.3
        }} data-id="element-593">
              {trend.value >= 0 ? '↑' : '↓'} {Math.abs(trend.value)}%
            </Typography>
          </Box>
          <Box sx={{
        height: 32,
        width: '100%'
      }} data-id="element-594">
            <Sparklines data={trend.data} width={100} height={32} data-id="element-595">
              <SparklinesLine color={color} style={{
            strokeWidth: 2,
            fill: 'none'
          }} data-id="element-596" />
            </Sparklines>
          </Box>
        </Box>}
    </Card>;
};
export default KPICard;